import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db, storage } from "../../Firebase_Config/firebaseConfig";
import { ref, getDownloadURL } from "firebase/storage";
import { FaArrowLeft } from "react-icons/fa";
import "./ViewBlog.css";

const ViewBlog = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState(true);
  const [previewOpen, setPreviewOpen] = useState(false);

  // Fetch blog from Firestore
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const docRef = doc(db, "blogPosts", blogId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          setBlog(null);
          return;
        }

        const data = docSnap.data();
        let imageUrl = data.ImgSrc || null;

        if (imageUrl && !imageUrl.startsWith("http")) {
          const storageRef = ref(storage, imageUrl);
          imageUrl = await getDownloadURL(storageRef);
        }

        setBlog({ id: docSnap.id, ...data, imageUrl });
      } catch (err) {
        console.error("Error fetching blog:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogId]);

  // Format date nicely
  const formatDateTime = (date) => {
    if (!date) return "Unknown date";

    let jsDate;
    if (date?.seconds) jsDate = new Date(date.seconds * 1000);
    else jsDate = new Date(date);

    if (isNaN(jsDate)) return "Unknown date";

    return jsDate.toLocaleString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Prevent scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = previewOpen ? "hidden" : "auto";
  }, [previewOpen]);

  if (loading)
    return (
      <p style={{ padding: "2rem", textAlign: "center" }}>Loading blog...</p>
    );

  if (!blog)
    return (
      <p style={{ padding: "2rem", textAlign: "center" }}>Blog not found.</p>
    );

  return (
    <>
      {/* Fixed Back Button */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        <FaArrowLeft size={18} /> Back
      </button>

      {/* Blog Container */}
      <div className="view-blog-container">
        <h1 className="view-blog-title">{blog.title}</h1>

        <p className="view-blog-meta">
          By <strong>{blog.author?.name || "Anonymous"}</strong> |{" "}
          {formatDateTime(blog.publishDate || blog.date)}
        </p>

        {blog.imageUrl ? (
          <div className="view-blog-image" onClick={() => setPreviewOpen(true)}>
            {imageLoading && (
              <div className="image-placeholder">
                <p>Loading image...</p>
              </div>
            )}
            <img
              src={blog.imageUrl}
              alt={blog.title}
              style={{ display: imageLoading ? "none" : "block" }}
              onLoad={() => setImageLoading(false)}
              onError={(e) => (e.target.style.display = "none")}
            />
          </div>
        ) : (
          <div className="view-blog-image placeholder">
            <p>No image available</p>
          </div>
        )}

        <div
          className="view-blog-content"
          dangerouslySetInnerHTML={{ __html: blog.postText }}
        />
      </div>

      {/* Image Modal */}
      {previewOpen && (
        <div className="image-modal" onClick={() => setPreviewOpen(false)}>
          <img src={blog.imageUrl} alt="Blog Preview" className="modal-img" />
        </div>
      )}
    </>
  );
};

export default ViewBlog;
